import { ptDateAddDays, ptEndOfMonth, ptThisWeekendRange, ptToday } from './timezone';

export type TimePreset = 'anytime' | 'today' | 'weekend' | 'next7days' | 'thisMonth' | 'custom';

/**
 * Resolve a time preset to an absolute PT date range (YYYY-MM-DD, inclusive).
 * Shared by All Activities, the homepage and /picks so "this weekend" means the
 * same days everywhere (docs/prd-homepage-redesign.md §3.5). Presets resolve on
 * read, so a saved link always reflects the viewer's today.
 */
export function resolveTimePreset(
  preset: TimePreset,
  custom: { dateFrom?: string; dateTo?: string } = {},
  now: Date = new Date()
): { from?: string; to?: string } {
  const today = ptToday(now);
  switch (preset) {
    case 'today':
      return { from: today, to: today };
    case 'weekend':
      return ptThisWeekendRange(now);
    case 'next7days':
      return { from: today, to: ptDateAddDays(today, 6) };
    case 'thisMonth':
      return { from: today, to: ptEndOfMonth(today) };
    case 'custom':
      return { from: custom.dateFrom || undefined, to: custom.dateTo || undefined };
    default:
      return {};
  }
}
